import { render, staticRenderFns } from "./educationCourseInfo.vue?vue&type=template&id=a4d8954c"
import script from "./educationCourseInfo.vue?vue&type=script&lang=js"
export * from "./educationCourseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4d8954c')) {
      api.createRecord('a4d8954c', component.options)
    } else {
      api.reload('a4d8954c', component.options)
    }
    module.hot.accept("./educationCourseInfo.vue?vue&type=template&id=a4d8954c", function () {
      api.rerender('a4d8954c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/cc/educationCourseInfo.vue"
export default component.exports